/* Pregfancy soft-luxury motion — no dependencies */
(function(){
  'use strict';
  var root=document.documentElement;
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
  var hasIO='IntersectionObserver' in window;

  /* 1. Reveal on scroll */
  function initReveal(scope){
    var els=(scope||document).querySelectorAll('[data-pf-reveal]:not(.is-in)');
    if(!els.length)return;
    if(!hasIO||reduce.matches){els.forEach(function(el){el.classList.add('is-in')});return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});
    },{rootMargin:'0px 0px -10% 0px',threshold:0.12});
    els.forEach(function(el){io.observe(el)});
    /* failsafe: never leave content hidden */
    setTimeout(function(){els.forEach(function(el){el.classList.add('is-in')})},4000);
  }

  /* 2. Scroll-linked effects (parallax + word reveal) — one rAF loop, only for visible elements */
  var live=new Set(),ticking=false;
  function measure(){
    ticking=false;
    var vh=window.innerHeight;
    live.forEach(function(el){
      var r=el.getBoundingClientRect();
      if(el.hasAttribute('data-pf-parallax')){
        var amt=parseFloat(el.getAttribute('data-pf-parallax'))||0.08;
        var center=(r.top+r.height/2-vh/2)/vh;
        el.style.setProperty('--pf-shift',(center*-amt*100).toFixed(2)+'px');
      }
      if(el.hasAttribute('data-pf-words')){
        var p=(vh*0.9-r.top)/(r.height*0.6+vh*0.3);
        el.style.setProperty('--p',Math.max(0,Math.min(1,p)).toFixed(3));
      }
    });
  }
  function onScroll(){if(!ticking){ticking=true;requestAnimationFrame(measure);}}
  function initScrollFx(){
    var els=document.querySelectorAll('[data-pf-parallax],[data-pf-words]');
    if(!els.length)return;
    if(reduce.matches||!hasIO){els.forEach(function(el){el.style.setProperty('--p','1')});return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){if(e.isIntersecting)live.add(e.target);else live.delete(e.target);});
      onScroll();
    },{rootMargin:'20% 0px 20% 0px'});
    els.forEach(function(el){io.observe(el)});
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onScroll,{passive:true});
  }

  /* 3. Sticky story: activate step in view, swap image */
  function initStory(){
    document.querySelectorAll('[data-pf-story]').forEach(function(story){
      var steps=story.querySelectorAll('[data-pf-step]');
      var media=story.querySelectorAll('[data-pf-story-media]');
      function activate(i){
        story.style.setProperty('--pf-step',i);
        steps.forEach(function(s,k){s.classList.toggle('is-active',k===i)});
        var wide=window.matchMedia('(min-width: 750px)').matches;var mi=wide?Math.min(i,media.length-1):0;
        if(media.length>1)media.forEach(function(m,k){m.classList.toggle('is-active',k===mi)});
      }
      activate(0);
      if(!hasIO)return;
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){if(e.isIntersecting)activate(Array.prototype.indexOf.call(steps,e.target));});
      },{rootMargin:'-45% 0px -45% 0px'});
      steps.forEach(function(s){io.observe(s)});
    });
  }

  /* 4. Accessible tabs */
  function initTabs(){
    document.querySelectorAll('[data-pf-tabs]').forEach(function(box){
      var tabs=box.querySelectorAll('[role="tab"]');
      function select(t,focus){
        tabs.forEach(function(x){
          var on=x===t;x.setAttribute('aria-selected',on);x.tabIndex=on?0:-1;
          var panel=document.getElementById(x.getAttribute('aria-controls'));
          if(panel){panel.hidden=!on;if(on)initReveal(panel);}
        });
        if(focus)t.focus();moveInd(box);
      }
      tabs.forEach(function(t,i){
        t.addEventListener('click',function(){select(t)});
        t.addEventListener('keydown',function(e){
          var n=null;
          if(e.key==='ArrowRight')n=tabs[(i+1)%tabs.length];
          if(e.key==='ArrowLeft')n=tabs[(i-1+tabs.length)%tabs.length];
          if(e.key==='Home')n=tabs[0];
          if(e.key==='End')n=tabs[tabs.length-1];
          if(n){e.preventDefault();select(n,true);}
        });
      });
    });
  }

  /* 5. Hero video: only when visible, motion allowed and not on data saver */
  function initVideo(){
    var save=navigator.connection&&navigator.connection.saveData;
    document.querySelectorAll('[data-pf-video]').forEach(function(v){
      var btn=v.parentNode.querySelector('[data-pf-video-toggle]');
      function setBtn(playing){if(btn){btn.setAttribute('aria-pressed',playing?'false':'true');btn.setAttribute('aria-label',playing?btn.dataset.pause:btn.dataset.play);}}
      if(reduce.matches||save){v.removeAttribute('autoplay');setBtn(false);}
      else if(hasIO){
        var io=new IntersectionObserver(function(en){en.forEach(function(e){
          if(e.isIntersecting&&!v.dataset.userPaused){v.play().then(function(){v.classList.add('is-playing');setBtn(true)}).catch(function(){})}
          else if(!e.isIntersecting){v.pause()}
        })},{threshold:0.25});
        io.observe(v);
      }
      if(btn)btn.addEventListener('click',function(){
        if(v.paused){delete v.dataset.userPaused;v.play();v.classList.add('is-playing');setBtn(true);}
        else{v.dataset.userPaused='1';v.pause();setBtn(false);}
      });
    });
  }

  /* 6. Header state on scroll (shadow only, no layout change) */
  function initHeader(){
    var h=document.querySelector('.header-main');if(!h)return;
    var last=false;
    window.addEventListener('scroll',function(){var s=window.scrollY>8;if(s!==last){last=s;root.classList.toggle('pf-scrolled',s);}},{passive:true});
  }


  /* 7. Hero rotator: word + image + chip change together; pausable; stops for reduced motion */
  function initRotator(){
    document.querySelectorAll('[data-pfx-rot]').forEach(function(box){
      var words=box.querySelectorAll('[data-pfx-word]'),slides=box.querySelectorAll('[data-pfx-slide]'),chips=box.querySelectorAll('[data-pfx-chiplink]'),dots=box.querySelectorAll('[data-pfx-dot]');
      var pause=box.querySelector('[data-pfx-pause]');
      var n=words.length,i=0,timer=null,ms=parseInt(box.getAttribute('data-pfx-rot'),10)||3800;
      if(n<2)return;
      function show(k){
        words.forEach(function(w,x){w.classList.toggle('is-out',x===i&&k!==i);w.classList.toggle('is-on',x===k)});
        slides.forEach(function(s,x){s.classList.toggle('is-on',x===Math.min(k,slides.length-1))});
        chips.forEach(function(c,x){c.hidden=x!==k});
        dots.forEach(function(d,x){d.setAttribute('aria-current',x===k?'true':'false')});
        i=k;
      }
      function start(){stop();if(reduce.matches||(pause&&pause.getAttribute('aria-pressed')==='true'))return;timer=setInterval(function(){show((i+1)%n)},ms);}
      function stop(){if(timer){clearInterval(timer);timer=null;}}
      dots.forEach(function(d,x){d.addEventListener('click',function(){show(x);start();})});
      if(pause){pause.addEventListener('click',function(){var p=pause.getAttribute('aria-pressed')==='true';pause.setAttribute('aria-pressed',p?'false':'true');pause.setAttribute('aria-label',p?pause.dataset.pause:pause.dataset.play);if(p)start();else stop();});}
      box.addEventListener('mouseenter',stop);box.addEventListener('mouseleave',start);
      box.addEventListener('focusin',stop);box.addEventListener('focusout',start);
      document.addEventListener('visibilitychange',function(){if(document.hidden)stop();else start();});
      if(reduce.matches&&pause){pause.setAttribute('aria-pressed','true');pause.setAttribute('aria-label',pause.dataset.play);}
      show(0);start();
    });
  }

  /* 8. Journey: pinned horizontal scroll on wide, fine-pointer screens; native swipe elsewhere */
  function initJourney(){
    document.querySelectorAll('[data-pfx-journey]').forEach(function(sec){
      var rail=sec.querySelector('.pfx-journey__rail'),track=sec.querySelector('.pfx-journey__track'),stages=sec.querySelectorAll('.pfx-stage'),labels=sec.querySelectorAll('.pfx-progress li');
      var mq=window.matchMedia('(min-width: 990px) and (pointer: fine)');
      var dist=0,raf=0,active=false;
      function layout(){
        var can=mq.matches&&!reduce.matches&&stages.length>1;
        sec.classList.toggle('is-pinned',can);
        active=can;
        if(!can){track.style.removeProperty('--pfx-x');return;}
        dist=Math.max(0,track.scrollWidth-sec.clientWidth);
        sec.style.setProperty('--pfx-rail',(window.innerHeight+dist)+'px');
        tick();
      }
      function tick(){
        raf=0;if(!active)return;
        var r=rail.getBoundingClientRect();
        var p=Math.max(0,Math.min(1,-r.top/Math.max(1,r.height-window.innerHeight)));
        track.style.setProperty('--pfx-x',(-p*dist).toFixed(1)+'px');
        sec.style.setProperty('--pfx-p',p.toFixed(3));
        var k=Math.round(p*(stages.length-1));
        stages.forEach(function(s,x){s.classList.toggle('is-near',x===k)});
        labels.forEach(function(l,x){l.classList.toggle('is-on',x<=k)});
      }
      function onScroll(){if(active&&!raf)raf=requestAnimationFrame(tick);}
      layout();
      window.addEventListener('scroll',onScroll,{passive:true});
      window.addEventListener('resize',function(){clearTimeout(sec._t);sec._t=setTimeout(layout,150)},{passive:true});
      if(mq.addEventListener)mq.addEventListener('change',layout);
      window.addEventListener('load',layout);
      /* keyboard users: focusing inside a stage scrolls the page to that stage */
      stages.forEach(function(s,x){s.addEventListener('focusin',function(){if(!active)return;var top=rail.getBoundingClientRect().top+window.scrollY;var p=stages.length>1?x/(stages.length-1):0;window.scrollTo({top:top+p*(rail.offsetHeight-window.innerHeight),behavior:'auto'});})});
    });
  }

  /* 9. Pillow finder */
  function initFinder(){
    document.querySelectorAll('[data-pfx-finder]').forEach(function(f){
      var res=f.querySelectorAll('[data-pfx-res]'),hint=f.querySelector('[data-pfx-hint]'),live=f.querySelector('[data-pfx-live]');
      function pick(){
        var sleep=f.querySelector('input[name="pfx-sleep-'+f.dataset.id+'"]:checked'),feed=f.querySelector('input[name="pfx-feed-'+f.dataset.id+'"]:checked');
        if(!sleep||!feed)return;
        var key=feed.value==='yes'?'feed':sleep.value;
        var shown=null;
        res.forEach(function(r){var on=r.getAttribute('data-pfx-res')===key;r.classList.toggle('is-on',on);if(on)shown=r;});
        if(hint)hint.hidden=true;
        if(live&&shown){var h=shown.querySelector('h3');live.textContent='Our suggestion: '+(h?h.textContent:'');}
      }
      f.addEventListener('change',pick);
    });
  }

  /* 10. Magnetic primary buttons (fine pointers only) */
  function initMagnet(){
    if(reduce.matches||!window.matchMedia('(pointer: fine)').matches)return;
    document.querySelectorAll('[data-pf-magnet]').forEach(function(b){
      b.addEventListener('pointermove',function(e){var r=b.getBoundingClientRect();var x=(e.clientX-r.left-r.width/2)*.18,y=(e.clientY-r.top-r.height/2)*.28;b.style.transform='translate3d('+x.toFixed(1)+'px,'+y.toFixed(1)+'px,0)';});
      b.addEventListener('pointerleave',function(){b.style.transform='';});
    });
  }

  /* 11. Tab indicator */
  function moveInd(box){
    var ind=box.querySelector('.pfh-tabs__ind'),on=box.querySelector('[aria-selected="true"]');
    if(!ind||!on)return;
    ind.style.setProperty('--x',on.offsetLeft+'px');ind.style.setProperty('--w',on.offsetWidth+'px');
  }

  /* FAQ page: turn h3 + following answer blocks into accessible accordions */
  function initFaq(){
    if(!document.body.classList.contains('tpl-faq'))return;
    var rte=document.querySelector('.main-page .rte');if(!rte||rte.querySelector('details'))return;
    var qs=rte.querySelectorAll('h3');if(qs.length<2)return;
    var wrap=document.createElement('div');wrap.className='pf-faq';
    rte.insertBefore(wrap,qs[0]);
    qs.forEach(function(h){
      var d=document.createElement('details'),s=document.createElement('summary'),a=document.createElement('div');
      a.className='pf-faq__a';s.textContent=h.textContent;
      var n=h.nextElementSibling;
      while(n&&n.tagName!=='H3'&&n.tagName!=='H2'){var nx=n.nextElementSibling;a.appendChild(n);n=nx;}
      d.appendChild(s);d.appendChild(a);wrap.appendChild(d);h.remove();
    });
  }
  window.pfSoftReveal=initReveal;
  function init(){initFaq();initReveal();initScrollFx();initStory();initTabs();initVideo();initHeader();initRotator();initJourney();initFinder();initMagnet();document.querySelectorAll('[data-pf-tabs]').forEach(moveInd);window.addEventListener('resize',function(){document.querySelectorAll('[data-pf-tabs]').forEach(moveInd)},{passive:true});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',function(e){initReveal(e.target);initStory();initTabs();initVideo();});
})();
